export function formatDate(fmt: Intl.DateTimeFormat, date?: Date, fallback = 'dd/mm/yyyy'): string {
    try {
        if (date) {
            return fmt.format(date);
        } else {
            return fallback;
        }
    } catch {
        // Intl.DateTimeFormat.format throws an error if the date is `Invalid`
        return fallback;
    }
}
